import BROWSER_STORAGE_KEY from '../config';

export const storeOrderInfo = (orderData, orderStatus) => {
  let stringifiedData;
  if (
    !(orderData && orderData.orderDetails && orderData.orderDetails.orderId) &&
    !orderStatus
  ) {
    return;
  }
  const data = {
    order_id: orderData?.orderDetails?.orderId,
    orderStatus,
    stored_at: new Date(),
  };
  try {
    stringifiedData = JSON.stringify(data);
  } catch (e) {
    stringifiedData = null;
  }
  if (stringifiedData) {
    localStorage.setItem(BROWSER_STORAGE_KEY, stringifiedData);
  }
};

export const clearBrowserStorageKey = (
  clearInMinutes,
  keyToClear,
  storedAt, // timeStamp
) => {
  const now = new Date();
  const expiration = new Date(storedAt);
  expiration.setMinutes(expiration.getMinutes() + clearInMinutes);

  if (now.getTime() > expiration.getTime()) {
    if (typeof localStorage === 'object') {
      try {
        localStorage.removeItem(keyToClear);
      } catch (e) {
        // console.log('local storage not available');
      }
    }
  }
};
